import { z } from 'zod';
import { sanitizeName } from '@/shared/utils/sanitize-name';

// Automation name validation
const automationNameValidation = z
  .string()
  .min(1, 'Automation name is required')
  .max(100, 'Automation name must be at most 100 characters')
  .transform(sanitizeName)
  .refine(
    val => val.length >= 2,
    'Automation name must be at least 2 characters',
  );

export const automationRenameSchema = z.object({
  displayName: automationNameValidation,
});

export type AutomationRenameFormData = z.infer<typeof automationRenameSchema>;

// Duplicate allows an empty name: when blank, the backend generates the
// default "Copy of <name>" itself, so the field is an optional override.
// Built via a factory so validation messages can be translated at render time.
export const createAutomationDuplicateSchema = (t: (key: string) => string) =>
  z.object({
    displayName: z
      .string()
      .max(100, t('automation.duplicateConfirmation.nameMaxLength'))
      .transform(sanitizeName)
      .refine(
        val => val.length === 0 || val.length >= 2,
        t('automation.duplicateConfirmation.nameMinLength'),
      ),
  });

export type AutomationDuplicateFormData = z.infer<
  ReturnType<typeof createAutomationDuplicateSchema>
>;
